import { render, staticRenderFns } from "./ShiftsSummaryPage.vue?vue&type=template&id=2b29c14c&"
import script from "./ShiftsSummaryPage.vue?vue&type=script&lang=js&"
export * from "./ShiftsSummaryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports